export default __webpack_public_path__ + "static/media/logo.98fbe4ef.svg";